import Vue from 'vue';
import Notification from '@/app/notification/notification';

export default new Vue({
    el        : '#notification',
    components: {Notification},
    template  : '<notification/>'
});
